import React, { useState } from 'react'
import { Header, Dropdown, Loader } from 'packages/eid-ui'
import { LanguageIcon } from 'packages/eid-icons'
import {
    useCurrentPerson,
    useAvailableLocales,
    useUpdatePersonLocale,
} from 'hooks'
import config from 'config'

const LanguagesList = () => {
    const { data: currentPerson } = useCurrentPerson()
    const locale =
        currentPerson && currentPerson.language?.languageCode
            ? currentPerson.language?.languageCode
            : 'en'

    const { isInitialLoading, data: availableLocales } = useAvailableLocales()

    const [currentLocale, setCurrentLocale] = useState(locale)

    const { mutateAsync: updateLocale } = useUpdatePersonLocale()

    const changeLocale = (locale) => {
        setCurrentLocale(locale.languageCode)
        updateLocale({
            id: locale.id,
        })
    }

    return (
        <>
            {isInitialLoading ? (
                <Loader height="0.5in" />
            ) : availableLocales.length === 0 ? (
                'No Languages Available'
            ) : (
                availableLocales.map((locale, index) => (
                    <Dropdown.LanguageMenuItem
                        onClick={() => changeLocale(locale)}
                        selected={currentLocale === locale.languageCode}
                        key={`${locale.nameOriginal}_{index}`}
                        avatarSrc={`${config.BASE_EID_URL}${locale.imageUrl}`}
                        displayName={locale.nameOriginal}
                    />
                ))
            )}
        </>
    )
}

const LanguageMenu = ({ showCone, ...rest }) => {
    const [open, setOpen] = useState(false)

    return (
        <Header.PopupMenu
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            displayIcon={
                <LanguageIcon width="24px" height="24px" color="#959598" />
            }
            menuHeight="45vh"
            showCone={showCone}
            {...rest}
        >
            {open && <LanguagesList />}
        </Header.PopupMenu>
    )
}

export default LanguageMenu
